import { useEffect } from "react";
import { useMutation } from "@apollo/client/react";
import toast from "react-hot-toast";
import { REENVIAR_MAIL_LIQUIDACION } from "../../../data/graphQL/queries/LiquidacionFinal/rvMailQueries";

export const useReenviarMail = ({ onSuccess }) => {
    const [reenviarMailMutation, { data, loading, error }] = useMutation(
        REENVIAR_MAIL_LIQUIDACION
    );

    const reenviarMail = async (rows, selectedIds) => {
        const liquidaciones = rows
            .filter((row) => selectedIds.includes(row.id))
            .map((row) => ({ idLiquidacionProfesional: row.id, esLegacy: row.esLegacy }));

        try {
            await reenviarMailMutation({ variables: { input: liquidaciones } });
        } catch {
            // el error se maneja en el useEffect
        }
    };

    useEffect(() => {
        if (data?.reenviarMailLiquidacion) {
            toast.success("Se reenvió el mail correctamente");
            onSuccess?.();
        }
    }, [data]);

    useEffect(() => {
        if (error) {
            toast.error(error.message ?? "Error al reenviar el mail");
        }
    }, [error]);

    return { reenviarMail, loading };
};